import {update} from './UTM';

const coordinateGridSpacing = [
    100000, // 0
    100000, // 1
    100000, // 2
    100000, // 3
    100000, // 4
    100000, // 5
    100000, // 6
    100000, // 7
    10000, // 8
    10000, // 9
    7500,  // 10
    5000,  // 11
    2500,  // 12
    1000,  // 13
    750,   // 14
    500,   // 15
    250,   // 16
    100,    // 17
    100,    // 18
    100,    // 19
    100,    // 20
];

const UTMGrid: GridGenerator = function (
    bounds: mapboxgl.LngLatBounds,
    zoom: number
): mapboxgl.Style {
    return update(bounds, zoom, coordinateGridSpacing);
};

export default UTMGrid;
